import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import CustomTextField from "../../theme-elements/CustomTextField";

const ControlledStateAutocomplete = ({
  options,
  setSelectedValue,
  customerId,
}) => {
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState("");

  // Initialize or update value when customerId changes
  React.useEffect(() => {
    if (customerId && options && options.length > 0) {
      const selectedCustomer = options.find(
        (option) => option.uuid === customerId
      );
      if (selectedCustomer) {
        setValue({
          uuid: selectedCustomer.uuid,
          name: selectedCustomer.name,
        });
      }
    }
  }, [customerId, options]);

  React.useEffect(() => {
    if (value) {
      setSelectedValue(
        options.find((option) => option.uuid === value.uuid) || null
      );
    }
  }, [value, options, setSelectedValue]);

  const formattedOptions =
    options?.map((customer) => ({
      uuid: customer.uuid,
      name: customer.name,
    })) || [];

  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      id="controllable-states-demo"
      options={formattedOptions}
      getOptionLabel={(option) => option.name || ""}
      isOptionEqualToValue={(option, value) =>
        option && value && option.uuid === value.uuid
      }
      fullWidth
      renderInput={(params) => (
        <CustomTextField
          {...params}
          placeholder="Pick a customer"
          aria-label="Controllable"
        />
      )}
    />
  );
};

export default ControlledStateAutocomplete;
